import { render } from "./livechatMessageTemplates.vue?vue&type=template&id=658bb7e6&scoped=true"
import script from "./livechatMessageTemplates.vue?vue&type=script&lang=js"
export * from "./livechatMessageTemplates.vue?vue&type=script&lang=js"

import "./livechatMessageTemplates.vue?vue&type=style&index=0&id=658bb7e6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658bb7e6"]])

export default __exports__